import script from "./ViewDepartments.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewDepartments.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__